import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import Icon from '../Icon/Icon';
import styles from './Button.module.scss';

const Button = ({ title, variant, iconName, ...defaultProps }) => {
	const Tag = variant === 'link' ? Link : 'button'; 

	return (
		<Tag className={styles[variant]} {...defaultProps}>
			{variant === 'iconButton' ? 
				<Icon name={iconName} size="24" color="none" strokeColor="#DD0000" /> :
				<span>{title}</span>}
		</Tag>
	);
};

Button.defaultProps = {
	variant: 'contained',
};

Button.propTypes = {
	title: PropTypes.string,
	iconName: PropTypes.string,
	variant: PropTypes.string,
};

export default Button;
